

































































import { Component, Vue } from "vue-property-decorator";
import finances from "../../store/modules/finances";

@Component
export default class TransactionsRouterView extends Vue {

}
